export default {
  getChannelData: state => state.channelData,
};
